import { BrowserRouter } from 'react-router-dom'
import { readEmbeddedPricing } from '../features/pricing/pricingApi'
import { AppRouter } from '../routes/AppRouter'
import { AppProviders } from './providers/AppProviders'

const embeddedPricing = readEmbeddedPricing()

export function App() {
  return (
    <BrowserRouter>
      <AppProviders initialPricing={embeddedPricing}>
        <AppRouter />
      </AppProviders>
    </BrowserRouter>
  )
}
